import React from 'react';
import styled from 'styled-components';

const Wrap = styled.a`
	color: rgba(255, 255, 255, 0.8);
	transition: all 0.4s ease-in;
	text-decoration: none;
	border-bottom: 2.5px solid ${props => props.theme.c};
	transition: 0.4s all ease-out;

	&:hover {
		box-shadow: inset 0 -5.5rem 0 ${props => props.theme.c};
		border-bottom: 3px solid ${props => props.theme.c};
		color: ${props => props.theme.c1};
	}
`;

export default props => <Wrap {...props}>{props.children}</Wrap>;
